import { ActionConfirm } from './ActionConfirm';
import { ActionInformation } from './ActionInformation';
import { ActionEmail } from './ActionEmail';
import { ActionForm } from './ActionForm';
import {ActionType} from './ActionType';
import {ActionChangeStatus} from './ActionChangeStatus';

export class SolutionStep {
  public id: number;
  public actionType: number | ActionType;
  public nextStep: number | SolutionStep;
  public actionForm: ActionForm;
  public actionEmail: ActionEmail;
  public actionInformation: ActionInformation;
  public actionConfirm: ActionConfirm;
  public actionChangeStatus: ActionChangeStatus;
}
